//import React, { Component, Suspense } from 'react';
//import { Route, Redirect, BrowserRouter, Switch } from 'react-router-dom';
//import Auth from './Auth/Auth';
//import SiteLoading from './Auth/SiteLoading';

//// Lazy-loaded components with preload capability
//const preloadableComponent = (importFunc) => {
//    const Component = React.lazy(importFunc);
//    Component.preload = importFunc;
//    return Component;
//};

//const UserLayoutAudits = preloadableComponent(() => import('./components/Audit/Users/UserLayoutAudits'));
//const UserLayoutScheduler = preloadableComponent(() => import('./components/Audit/Users/UserLayoutScheduler'));
//const ReportLayout = preloadableComponent(() => import('./components/Audit/Reports/ReportLayout'));
//const BillingLayout = preloadableComponent(() => import('./components/Audit/Billing/BillingLayout'));
//const SchedulerLayout = preloadableComponent(() => import('./components/Scheduler/SchedulerLayout'));
//const RequestLayout = preloadableComponent(() => import('./components/Scheduler/Requests/RequestsLayout'));
//const ShiftLayout = preloadableComponent(() => import('./components/Scheduler/Shifts/ShiftLayout'));
//const ScheduleReportLayout = preloadableComponent(() => import('./components/Scheduler/Reports/ScheduleReportLayout'));
//const EmployeeRequestsLayout = preloadableComponent(() => import('./components/Scheduler/Employee/EmployeeRequestsLayout'));
//const EmployeeScheduleLayout = preloadableComponent(() => import('./components/Scheduler/Employee/EmployeeScheduleLayout'));
//const Callback = preloadableComponent(() => import('./components/Callback'));
//const Signup = preloadableComponent(() => import('./Auth/Signup'));
//const LoginForm = preloadableComponent(() => import('./Auth/LoginForm'));
//const ForgotPassword = preloadableComponent(() => import('./Auth/ForgotPassword'));
//const LogOut = preloadableComponent(() => import('./Auth/LogOut'));
//const Setup = preloadableComponent(() => import('./components/Setup/Setup'));
//const SettingsLayout = preloadableComponent(() => import('./components/Settings/SettingsLayout'));
//const SettingsLayoutAudit = preloadableComponent(() => import('./components/Settings/SettingsLayoutAudit'));
//const EmployeeColleagueLayout = preloadableComponent(() => import('./components/Scheduler/Employee/EmployeeColleagueLayout'));
//const ChatLayout = preloadableComponent(() => import('./components/Scheduler/Messaging/ChatLayout'));
//const Error = preloadableComponent(() => import('./components/Error/error'));
//const FourZeroFour = preloadableComponent(() => import('./components/Error/FourZeroFour'));
//const ActivateAccount = preloadableComponent(() => import('./Auth/ActivateAccount'));
//const Uikit = preloadableComponent(() => import('./UiKit/Uikit'));
//const Theme = preloadableComponent(() => import('./Theme'));
//const Dashboard = preloadableComponent(() => import('./components/Scheduler/Dashboard/Dashboard'));
//const NurseDashboard = preloadableComponent(() => import('./components/Audit/Nurse/NurseDashboard'));
//const CourseList = preloadableComponent(() => import('./components/Scheduler/Courses/CourseList'));
//const CoursesComplete = preloadableComponent(() => import('./components/Scheduler/Courses/CoursesComplete'));
//const CoursesInComplete = preloadableComponent(() => import('./components/Scheduler/Courses/CoursesInComplete'));
//const CreateCourseWrapper = preloadableComponent(() => import('./components/Courses/CreateCourseWrapper'));
//const AuditList = preloadableComponent(() => import('./components/Forms/Audits/AuditList'));
//const AuditsDetails = preloadableComponent(() => import('./components/Forms/Audits/AuditsDetails'));
//const AuditsInComplete = preloadableComponent(() => import('./components/Forms/Audits/AuditsInComplete'));
//const QuizEmbed = preloadableComponent(() => import('./components/Courses/Quiz/QuizEmbed'));
//const Timesheets = preloadableComponent(() => import('./components/Timesheets/Timesheets'));
//const TimeClock = preloadableComponent(() => import('./components/Timesheets/TimeClock'));
//const Audit = preloadableComponent(() => import('./components/Forms/Audits/Audit'));
//const FormsLayout = preloadableComponent(() => import('./components/Forms/FormsLayout'));
//const CourseCreate = preloadableComponent(() => import('./components/Scheduler/Courses/CourseCreate'));
//const TemplateAddEdit = preloadableComponent(() => import('./components/Forms/Templates/CreateTemplate/TemplateAddEdit'));
//const AuditsLayout = preloadableComponent(() => import('./components/Forms/Audits/AuditsLayout'));
//const FormCreate = preloadableComponent(() => import('./components/Forms/FormCreate'));
//const UserForms = preloadableComponent(() => import('./components/Forms/Forms/UserForms'));
//const AuditCreate = preloadableComponent(() => import('./components/Forms/Audits/AuditCreate'));
//const PasswordReset = preloadableComponent(() => import('./Auth/PasswordReset'));
//const NavMenu = preloadableComponent(() => import('./components/NavMenu'));
//const Layout = preloadableComponent(() => import('./components/Layout'));
//const Demo = preloadableComponent(() => import('./Auth/Demo'));
//const PricingTable = preloadableComponent(() => import('./Auth/PricingTable'));
//const CheckoutSuccess = preloadableComponent(() => import('./Auth/CheckoutSuccess'));
//const EmployeeDashboard = preloadableComponent(() => import('./components/Scheduler/Employee/EmployeeDashboard'));

//// Preload all components
//const preloadAllRoutes = () => {
//    const components = [
//        UserLayoutAudits,
//        UserLayoutScheduler,
//        ReportLayout,
//        BillingLayout,
//        SchedulerLayout,
//        RequestLayout,
//        ShiftLayout,
//        ScheduleReportLayout,
//        EmployeeRequestsLayout,
//        EmployeeScheduleLayout,
//        Callback,
//        Signup,
//        LoginForm,
//        ForgotPassword,
//        LogOut,
//        Setup,
//        SettingsLayout,
//        SettingsLayoutAudit,
//        EmployeeColleagueLayout,
//        ChatLayout,
//        Error,
//        FourZeroFour,
//        ActivateAccount,
//        Uikit,
//        Theme,
//        Dashboard,
//        NurseDashboard,
//        CourseList,
//        CoursesComplete,
//        CoursesInComplete,
//        CreateCourseWrapper,
//        AuditList,
//        AuditsDetails,
//        AuditsInComplete,
//        QuizEmbed,
//        Timesheets,
//        TimeClock,
//        Audit,
//        FormsLayout,
//        CourseCreate,
//        TemplateAddEdit,
//        AuditsLayout,
//        FormCreate,
//        UserForms,
//        AuditCreate,
//        PasswordReset,
//        NavMenu,
//        Layout,
//        Demo,
//        PricingTable,
//        CheckoutSuccess,
//        EmployeeDashboard,
//    ];

//    components.forEach((component) => {
//        if (component.preload) {
//            component.preload();
//        }
//    });
//};

//const isLoggedIn = () => {
//    // Check whether the current time is past the
//    // access token's expiry time
//    let expiresAt = new Date(localStorage.getItem('expires_at'));
//    let isAuthed = new Date().getTime() < expiresAt;
//    if (isAuthed && localStorage.getItem("access_token")) {
//        return true;
//    }
//    return false;
//}

//class Routes extends Component {
//    constructor(props) {
//        super(props);
//        this.auth = new Auth(this.props.history);
//    }

//    componentDidMount() {
//        preloadAllRoutes(); // Preload all routes when the app mounts
//    }
//    handleAuthentication = ({ location, history }) => {
//        debugger;
//        if (/access_token|id_token|error/.test(location.hash)) {

//            this.auth.handleAuthentication(history);
//        }
//    }

//    showNav = () => {
//        return (window.location.pathname.indexOf("signup") === 0
//            && window.location.pathname.indexOf("login") === 0
//            && window.location.pathname.indexOf("demo") === 0
//            && window.location.pathname === "/"
//            && window.location.pathname.indexOf("logout") === 0
//            && window.location.pathname.indexOf("forgot_password") === 0
//            && window.location.pathname.indexOf("reset_password") === 0)
//    }
//    render() {
//        return (
//            <BrowserRouter>
//                <Suspense fallback={<SiteLoading />}>
//                    <Theme />
//                    {localStorage.getItem("access_token") && !this.props.hideNav && this.showNav() &&
//                        <NavMenu />
//                    }
//                    <Switch>
//                        <Route path="/activate" component={ActivateAccount} />
//                        <Route path="/signup" component={Signup} />
//                        <Route path="/login" component={LoginForm} />
//                        <Route path="/logout" component={LogOut} />
//                        <Route path="/forgot_password" component={ForgotPassword} />
//                        <Route path="/reset_password" component={PasswordReset} />
//                        <Route path="/demo" component={Demo} />
//                        <Route path="/setup" component={Setup} />
//                        <Route path="/error" component={Error} />
//                        <Route path="/uikit" component={Uikit} />
//                        <Route exact path="/time-clock" component={TimeClock} />
//                        <Route path="/404" component={FourZeroFour} />
//                        <Route path="/callback" render={(props) => { this.handleAuthentication(props); return <Callback {...props} /> }} />
//                        {window.location.pathname === "/" && <NoRouteFound />}
//                        <Route>
//                            <Layout>
//                                <Switch>
//                                    <PrivateRoute roles="2" path="/scheduler/overview" component={Dashboard} />
//                                    <PrivateRoute roles="2" path="/settings/:slug?" component={SettingsLayout} />
//                                    <PrivateRoute roles="3" path="/checkout-success" component={CheckoutSuccess} />
//                                    <PrivateRoute roles="3" path="/plans" component={PricingTable} />
//                                    <PrivateRoute roles="3" path="/chats" component={ChatLayout} />
//                                    <PrivateRoute roles="3" path="/scheduler/my-schedule/:slug?/:id?" component={EmployeeScheduleLayout} />
//                                    <PrivateRoute roles="3" path="/schedule/requests/:slug?" component={EmployeeRequestsLayout} />
//                                    <PrivateRoute roles="3" path="/scheduler/colleagues" component={EmployeeColleagueLayout} />
//                                    <PrivateRoute roles="2" path="/scheduler/users/:slug?" component={UserLayoutScheduler} />
//                                    <PrivateRoute roles="2" path="/scheduler/requests/:slug?" component={RequestLayout} />
//                                    <PrivateRoute roles="2" path="/scheduler/templates/:slug?/:id?" component={ShiftLayout} />
//                                    <PrivateRoute roles="2" path="/scheduler/schedule/:slug?/:id?" component={SchedulerLayout} />
//                                    <PrivateRoute roles="2" path="/scheduler/schedule/assign-shifts/:date?" component={SchedulerLayout} />
//                                    <PrivateRoute roles="2" path="/scheduler/shifts/:slug?/:path?/:id?" component={ShiftLayout} />
//                                    <PrivateRoute exact roles="2" path="/course/create" component={CreateCourseWrapper} />
//                                    <PrivateRoute exact roles="2" path="/quiz/overview" component={CourseList} />
//                                    <PrivateRoute exact roles="2" path="/quiz/create" component={CourseCreate} />
//                                    <PrivateRoute exact roles="2" path="/quiz/complete/:type?/:id?" component={CoursesComplete} />
//                                    <PrivateRoute exact roles="2" path="/quiz/incomplete/:type?/:id?" component={CoursesInComplete} />
//                                    <PrivateRoute exact roles="2" path="/scheduler/audits/overview" component={AuditList} />
//                                    <PrivateRoute exact roles="2" path="/scheduler/audits/complete/:type/:id/:templateTypeId" component={AuditsDetails} />
//                                    <PrivateRoute exact roles="2" path="/scheduler/audits/incomplete/:type/:id/:templateTypeId" component={AuditsInComplete} />
//                                    <PrivateRoute exact roles="2" path="/audits/template/:id?" component={TemplateAddEdit} />
//                                    <PrivateRoute exact roles="2" path="/scheduler/forms/:slug/:type?/:id?/:templateTypeId?" component={FormsLayout} />
//                                    <PrivateRoute exact roles="3" path="/user/forms" component={UserForms} />
//                                    <PrivateRoute exact roles="3" path="/user/dashboard" component={EmployeeDashboard} />
//                                    <PrivateRoute exact roles="2" path="/forms/create" component={FormCreate} />
//                                    <PrivateRoute exact roles="2" path="/audit/create" component={AuditCreate} />
//                                    <PrivateRoute exact roles="2" path="/forms/e/:type" component={TemplateAddEdit} />
//                                    <PrivateRoute exact roles="2" path="/forms/:slug?" component={FormsLayout} />
//                                    <PrivateRoute exact roles="2" path="/audits/:slug?" component={AuditsLayout} />
//                                    <PrivateRoute exact roles="2" path="/audits/e/audit" component={TemplateAddEdit} />
//                                    <PrivateRoute exact path="/audits/c/audit" component={Audit} />
//                                    <PrivateRoute exact roles="2" path="/reports/:type?/:slug?/:details?" component={ScheduleReportLayout} />
//                                    <PrivateRoute exact roles="2" path="/timesheets" component={Timesheets} />
//                                    <PrivateRoute exact roles="2" path="/admin/users/:slug?/:id?" component={UserLayoutAudits} />
//                                    <PrivateRoute exact roles="2" path="/admin/reports/:slug?/:id?/:year?" component={ReportLayout} />
//                                    <PrivateRoute exact roles="2" path="/admin/billing/:slug?/:plan?" component={BillingLayout} />
//                                    <PrivateRoute exact roles="3" path="/admin/overview/audits" component={NurseDashboard} />
//                                    <PrivateRoute exact roles="2" path="/admin/settings/:slug" component={SettingsLayoutAudit} />
//                                    <Route path="/course/:id" component={QuizEmbed} />
//                                    <NoRouteFound />
//                                    <Redirect to="/404" />
//                                </Switch>
//                            </Layout>
//                        </Route>
//                    </Switch>
//                </Suspense>
//            </BrowserRouter>
//        );
//    }
//};

//const NoRouteFound = ({ checklogin, ...rest }) => {
//    var userType = JSON.parse(localStorage.getItem("user_type"));
//    if (isLoggedIn() && userType == "3") {
//        // Employees
//        window.location.href = '/scheduler/my-schedule';

//    } else if (isLoggedIn()) {
//        window.location.href = '/scheduler/overview';
//    } else {
//        window.location.href = "/login";
//    }
//};

//const PrivateRoute = ({ component: Component, checklogin, product, roles, ...rest }) => (
//    <Route
//        {...rest}
//        render={props => {
//            var profile = JSON.parse(localStorage.getItem("userProfile"));
//            var userType = profile.userType;
//            if (userType.includes(roles) || roles == null || userType == "1") {
//                return <Component {...props} />
//            } else if ((userType == "3") && product == 'chart-audits') {
//                return <Redirect to={{ pathname: '/admin/overview/audits', state: { from: props.location } }} />
//            } else if ((userType == "3") && product == 'scheduler') {
//                return <Redirect to={{ pathname: '/scheduler/my-schedule', state: { from: props.location } }} />
//            } else {
//                window.location.href = "/login";
//            }
//        }}
//    />
//);

//export default Routes;



import React, { Component, PropTypes, Fragment, Suspense } from 'react'
import { Route, Redirect, BrowserRouter, Switch } from 'react-router-dom';
import Auth from './Auth/Auth';
import SiteLoading from './Auth/SiteLoading';
import PendingSwitch from './components/PendingSwitch';

// --- Eager: small / login-critical / always rendered ---
import Theme from './Theme'
import NavMenu from './components/NavMenu';
import Layout from './components/Layout';
import Callback from './components/Callback';
import Signup from './Auth/Signup'
import LoginForm from './Auth/LoginForm'
import ForgotPassword from './Auth/ForgotPassword'
import LogOut from './Auth/LogOut'
import PasswordReset from './Auth/PasswordReset';
import ActivateAccount from './Auth/ActivateAccount';
import Demo from './Auth/Demo';
import Error from './components/Error/error'
import FourZeroFour from './components/Error/FourZeroFour'
import Setup from './components/Setup/Setup'

// --- Lazy: authenticated app + heavy / rarely used routes ---
// Defined in ./lazyRoutes so Layout.componentDidMount can prefetch the SAME
// component references (sharing `.preload()` and the `.loaded` flag with
// PendingSwitch, so cached navigations don't flash the top loading bar).
import {
    Dashboard, SchedulerLayout, ShiftLayout, RequestLayout, ScheduleReportLayout,
    UserLayoutScheduler, UserLayoutAudits, ReportLayout, BillingLayout, NurseDashboard,
    SettingsLayout, SettingsLayoutAudit,
    EmployeeScheduleLayout, EmployeeRequestsLayout, EmployeeColleagueLayout,
    NotificationsAlertsLayout, EmployeeDashboard,
    ChatLayout,
    FormsLayout, FormCreate, UserForms, TemplateAddEdit,
    AuditsLayout, AuditList, AuditsDetails, AuditsInComplete, AuditCreate, Audit,
    CourseList, CourseCreate, CoursesComplete, CoursesInComplete, CreateCourseWrapper,
    QuizEmbed, QuizzesPage,
    Timesheets, TimeClock, TaskManagerLayout,
    PricingTable, CheckoutSuccess, OnboardingFlow, QuickStart,
    Uikit, TestOverview, TestEdit, TestRun, Test, TasksTest,
    HelpCenterLayout, HelpCenterCategories, HelpCenterCategoryDetails, HelpCenterArticleDetails,
} from './lazyRoutes';

const isLoggedIn = () => {
    // Check whether the current time is past the 
    // access token's expiry time
    let expiresAt = new Date(localStorage.getItem('expires_at'));
    let isAuthed = new Date().getTime() < expiresAt;
    if (isAuthed && localStorage.getItem("access_token")) {
        return true;
    }
    return false;
}

class Routes extends Component {
    constructor(props) {
        super(props);
        this.auth = new Auth(this.props.history);
        this.state = {
            breadcrumbs: [
                { text: 'All Collections', to: '/help-center', key: 'categories' }
            ]
        };
        this.setBreadcrumbs = this.setBreadcrumbs.bind(this);
    }
    setBreadcrumbs(breadcrumbs) {
        this.setState({ breadcrumbs });
    }
    handleAuthentication = ({ location, history }) => {
        if (/access_token|id_token|error/.test(location.hash)) {

            this.auth.handleAuthentication(history);
        }
    }

    showNav = () => {
        return (window.location.pathname.indexOf("signup") === 0
            && window.location.pathname.indexOf("login") === 0
            && window.location.pathname.indexOf("demo") === 0
            && window.location.pathname === "/"
            && window.location.pathname.indexOf("logout") === 0
            && window.location.pathname.indexOf("tests") === 0
            && window.location.pathname.indexOf("forgot_password") === 0
            && window.location.pathname.indexOf("reset_password") === 0)
    }
    render() {
        return (
            <BrowserRouter>
                <Theme />
                {localStorage.getItem("access_token") && !this.props.hideNav && this.showNav() &&
                    <NavMenu />
                }
                <Suspense fallback={<SiteLoading />}>
                <Switch>
                    <Route path="/activate" component={ActivateAccount} />
                    <Route path="/signup" component={Signup} />
                    <PrivateRoute path="/onboarding" component={OnboardingFlow} />
                    <Route path="/login" component={LoginForm} />
                    <Route path="/logout" component={LogOut} />
                    <Route path="/forgot_password" component={ForgotPassword} />
                    <Route path="/reset_password" component={PasswordReset} />
                    <Route path="/demo" component={Demo} />
                    <Route path="/setup" component={Setup} />
                    <Route path="/error" component={Error} />
                    <Route path="/tests" component={TestOverview} />
                    <Route path="/tests-edit/:testId?" component={TestEdit} />
                    <Route path="/test-run/:TestRunId?" component={TestRun} />
                    <Route path="/test/:TestRunxTestsId?" component={Test} />
                    <Route path="/tasks-test" component={TasksTest} />
                    <Route path="/uikit" component={Uikit} />
                    <Route exact path="/time-clock" component={TimeClock} />
                    <Route path="/404" component={FourZeroFour} />
                    <Route path="/callback" render={(props) => { this.handleAuthentication(props); return <Callback {...props} /> }} />
                    {/* Help Center routes with persistent HelpCenterLayout */}
                    <Route path="/help-center">
                      {({ location }) => (
                        <HelpCenterLayout
                          breadcrumbs={this.state.breadcrumbs.length > 1 ? this.state.breadcrumbs : null}
                          showSearchText={location.pathname === "/help-center"}
                        >
                          <Switch>
                            <Route path="/help-center/category/:categoryId" render={props => <HelpCenterCategoryDetails {...props} setBreadcrumbs={this.setBreadcrumbs} />} />
                            <Route path="/help-center/article/:articleId" render={props => <HelpCenterArticleDetails {...props} setBreadcrumbs={this.setBreadcrumbs} />} />
                            <Route path="/help-center" render={props => <HelpCenterCategories {...props} setBreadcrumbs={this.setBreadcrumbs} showSearchText={true} />} />
                          </Switch>
                        </HelpCenterLayout>
                      )}
                    </Route>
                     {window.location.pathname === "/" && <NoRouteFound />}
                    {/* Main app routes with main Layout */}
                    <Route>
                        <Layout>
                            <PendingSwitch>
                                <PrivateRoute roles="2" path="/scheduler/overview" component={Dashboard} />
                                <PrivateRoute roles="2" path="/quickstart" component={QuickStart} />
                                <PrivateRoute exact roles="2" path="/settings/clients" component={SettingsLayout} />
                                <PrivateRoute roles="2" path="/settings/:slug?" component={SettingsLayout} />
                                <PrivateRoute roles="3" path="/checkout-success" component={CheckoutSuccess} />
                                <PrivateRoute roles="3" path="/plans" component={PricingTable} />
                                <PrivateRoute roles="3" path="/chats" component={ChatLayout} />
                                <PrivateRoute roles="3" path="/scheduler/my-schedule/:slug?/:id?" component={EmployeeScheduleLayout} />
                                <PrivateRoute roles="3" path="/schedule/requests/:slug?" component={EmployeeRequestsLayout} />
                                <PrivateRoute roles="3" path="/scheduler/colleagues" component={EmployeeColleagueLayout} />
                                <PrivateRoute roles="3" path="/notifications-alerts" component={NotificationsAlertsLayout} />
                                <PrivateRoute roles="3" path="/quizzes" component={QuizzesPage} />
                                <PrivateRoute roles="2" path="/scheduler/users/:slug?" component={UserLayoutScheduler} />
                                <PrivateRoute roles="2" path="/scheduler/requests/:slug?" component={RequestLayout} />
                                <PrivateRoute roles="2" path="/scheduler/templates/:slug?/:id?" component={ShiftLayout} />
                                <PrivateRoute roles="2" path="/scheduler/schedule/:slug?/:id?" component={SchedulerLayout} />
                                <PrivateRoute roles="2" path="/scheduler/schedule/assign-shifts/:date?" component={SchedulerLayout} />
                                <PrivateRoute roles="2" path="/scheduler/shifts/:slug?/:path?/:id?" component={ShiftLayout} />
                                <PrivateRoute exact roles="2" path="/course/create" component={CreateCourseWrapper} />
                                <PrivateRoute exact roles="2" path="/quiz/overview" component={CourseList} />
                                <PrivateRoute exact roles="2" path="/quiz/create" component={CourseCreate} />
                                <PrivateRoute exact roles="2" path="/quiz/complete/:type?/:id?" component={CoursesComplete} />
                                <PrivateRoute exact roles="2" path="/quiz/incomplete/:type?/:id?" component={CoursesInComplete} />
                                <PrivateRoute exact roles="2" path="/scheduler/audits/overview" component={AuditList} />
                                <PrivateRoute exact roles="2" path="/scheduler/audits/complete/:type/:id/:templateTypeId" component={AuditsDetails} />
                                <PrivateRoute exact roles="2" path="/scheduler/audits/incomplete/:type/:id/:templateTypeId" component={AuditsInComplete} />
                                <PrivateRoute exact roles="2" path="/audits/template/:id?" component={TemplateAddEdit} />
                                <PrivateRoute exact roles="2" path="/scheduler/forms/:slug/:type?/:id?/:templateTypeId?" component={FormsLayout} />
                                <PrivateRoute exact roles="3" path="/user/forms" component={UserForms} />
                                <PrivateRoute exact roles="3" path="/user/dashboard" component={EmployeeDashboard} />
                                <PrivateRoute exact roles="2" path="/forms/create" component={FormCreate} />
                                <PrivateRoute exact roles="2" path="/audit/create" component={AuditCreate} />
                                <PrivateRoute exact roles="2" path="/forms/e/:type" component={TemplateAddEdit} />
                                <PrivateRoute exact roles="2" path="/forms/:slug?" component={FormsLayout} />
                                <PrivateRoute exact roles="2" path="/audits/:slug?" component={AuditsLayout} />
                                <PrivateRoute exact roles="2" path="/tasks/:slug?" component={TaskManagerLayout} />
                                <PrivateRoute exact roles="2" path="/audits/e/audit" component={TemplateAddEdit} />
                                <PrivateRoute exact path="/audits/c/audit" component={Audit} />
                                <PrivateRoute exact roles="2" path="/reports/:type?/:slug?/:details?" component={ScheduleReportLayout} />
                                <PrivateRoute exact roles="2" path="/timesheets" component={Timesheets} />
                                <PrivateRoute exact roles="2" path="/admin/users/:slug?/:id?" component={UserLayoutAudits} />
                                <PrivateRoute exact roles="2" path="/admin/reports/:slug?/:id?/:year?" component={ReportLayout} />
                                <PrivateRoute exact roles="2" path="/admin/billing/:slug?/:plan?" component={BillingLayout} />
                                <PrivateRoute exact roles="3" path="/admin/overview/audits" component={NurseDashboard} />
                                <PrivateRoute exact roles="2" path="/admin/settings/:slug" component={SettingsLayoutAudit} />
                                <Route path="/course/:id" component={QuizEmbed} />
                                <NoRouteFound />
                                <Redirect to="/404" />
                            </PendingSwitch>
                        </Layout>
                    </Route>
                </Switch>
                </Suspense>
            </BrowserRouter>
        );
    }
};

const NoRouteFound = ({ checklogin, ...rest }) => {
    var userType = JSON.parse(localStorage.getItem("user_type"));
    if (isLoggedIn() && userType == "3") {
        // Employees
        window.location.href = '/scheduler/my-schedule';

    } else if (isLoggedIn()) {
        window.location.href = '/scheduler/overview';
    } else {
        window.location.href = "/login";
    }
};

const PrivateRoute = ({ component: Component, checklogin, product, roles, ...rest }) => (
    <Route
        {...rest}
        render={props => {
            const storedProfile = localStorage.getItem("userProfile");
            const profile = storedProfile ? JSON.parse(storedProfile) : null;
            const storedUserType = localStorage.getItem("user_type");
            const parsedUserType = storedUserType ? JSON.parse(storedUserType) : null;
            const userType = (profile && profile.userType) || (parsedUserType != null ? parsedUserType.toString() : null);
            const isOnboardingRoute = props.location.pathname.indexOf('/onboarding') === 0;

            if (!isLoggedIn()) {
                return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />;
            }

            if (!userType) {
                return isOnboardingRoute ? <Component {...props} /> : null;
            }

            if (userType.includes(roles) || roles == null || userType == "1" || userType == "2") {
                return <Component {...props} />
            } else if ((userType == "3") && product == 'chart-audits') {
                return <Redirect to={{ pathname: '/admin/overview/audits', state: { from: props.location } }} />
            } else if ((userType == "3") && product == 'scheduler') {
                return <Redirect to={{ pathname: '/scheduler/my-schedule', state: { from: props.location } }} />
            } else {
                window.location.href = "/login";
            }
        }}
    />
);

export default Routes;
